




































































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { NewResults } from "../../types/NewResults";
import { Action, Getter } from "vuex-class";
import bodymovin from "lottie-web";
import resultsprocessing from "@/assets/lottiefiles/resultsprocessing.json";
import Recorder from "@/components/record/recorder.vue";
import LearnerResults from "@/views/learner/learnerresults.vue";
import ParrotMicEyes from "@/assets/images/parrot/ParrotMicEyes.svg?inline";
import ErrorParrot from "@/assets/images/parrot/ErrorParrot2.svg?inline";

import { getDomain } from "@/auth";
import { source, refreshAxiosCancelToken } from "@/store/actions";
import amplitude from "amplitude-js";
import consts from "../../consts";
import Uploader from "@/components/record/uploader.vue";

@Component({
  components: {
    Recorder,
    LearnerResults,
    ParrotMicEyes,
    ErrorParrot,
    Uploader,
  },
})
export default class LearnerPractice extends Vue {
  private showRecord: boolean = false;
  private results: NewResults | null = null;
  private finishedRecording: boolean = false;
  private timenow: number = Date.now();
  private recordError: string | null = null;
  private displayNoMediaAccessError = false;
  private recordVideo = false;

  @Action private resetState: any;
  private $amplitude: any;

  private created() {
    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();
  }

  constructor() {
    super();
    //this.finishedRecording = true;
  }

  private onResults(myresults: any) {
    this.results = myresults;
    console.log("onResults");
    console.log(this.results);
    if (
      this.recordError === null &&
      this.results !== null &&
      this.results.Results !== null &&
      this.results.Errors === null
    ) {
      this.$router.push({
        name: "learnerresults",
        params: {
          sid: this.results.ID,
          propResults: JSON.stringify(this.results.Results),
        },
      });
    } else if (this.results !== null && this.results.Errors !== null) {
      this.recordError = this.results.Errors;
    }
  }

  private lottieInit(el: Element) {
    bodymovin.loadAnimation({
      container: el,
      renderer: "svg",
      loop: true,
      animationData: resultsprocessing,
    });
  }

  private resetRecording() {
    console.log("reset");
    this.results = null;
    this.recordError = null;
    this.finishedRecording = false;
    this.timenow = Date.now();
    this.recordError = null;
    //window.location.reload();
  }

  private onRecordFail(e: Event) {
    if (e.type === "missing-av-permissions") {
      this.recordError =
        "Please enable your microphone and camera access and try again.";
    } else {
      this.recordError =
        "A network or system error has occured. Please try again";
    }
  }

  // private mounted() {
  //   let svgContainer = this.$refs.processing as Element;
  //   this.lottieInit(svgContainer!, resultsprocessing);
  // }

  private onProcessing() {
    this.finishedRecording = true;
    let svgContainer = this.$refs.processing as Element;
    this.lottieInit(svgContainer!);
  }
}
